import React, { useCallback } from "react";

import Segmented, { SegmentedProps } from "antd/es/segmented";
import cn from "classnames";

import styles from "./SegmentedSwitch.module.scss";

interface Props<T> extends Omit<SegmentedProps, "onChange" | "ref" | "value"> {
  onChange?: (value: T) => void;
  value?: T;
}

const SegmentedSwitch = <T extends number | string>({
  className,
  onChange,
  value,
  ...props
}: Props<T>) => {
  const handleChange = useCallback((value: number | string) => onChange?.(value as T), [onChange]);
  return (
    <Segmented
      className={cn(styles.container, className)}
      onChange={handleChange}
      value={value}
      {...props}
    />
  );
};

export default SegmentedSwitch;
